import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import React from "react";
import { createGlobalStyle } from "styled-components";
import Diagperm from "../common/Icon/diagperm.png";
import { useNavigate } from "react-router-dom";

// page 404

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container className="notFoundContainer">
      <Styles />
      <img
        className="not-found-logo"
        id="img-not-found"
        alt="404"
        src={Diagperm}
      ></img>
       <Word
                value="Oh! oh! vous vous êtes perdu?"
                textStyle="normalReg"
                variant="p"
                automatedTestId="id-message"
                className="not-found-message"
              />
               <Button className="message-btn" automatedTestId="id-btn" mode="plain"
               onClick={()=> navigate(-1)}>
                      <Word
                        variant="span"
                        textStyle="normalBold"
                        value="Retour à la page précédente"
                      />
                    </Button>
    </Container>
  );
};
const Styles = createGlobalStyle`
.sds-reset-style{
 
.notFoundContainer{
  margin-left: auto;
  margin-right: auto;
  .not-found-logo{
    width: 50%;
    margin: auto;
    margin-bottom:2%;
  }
  .message-btn, .not-found-message{
    align-self: center;
  }
}
}
 
`;
export default NotFound;
